import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取信控配置
export function getCreditConfig(params) {
  return request({
    url: URL.sys.getCreditConfig,
    method: 'get',
    params
  })
}
